uic-virtual-scroll {
    display: block;
    height: 100%;
}

.uic-virtual-scroll__scroller {
    display: block;
    flex: 1 1 auto;
    height: 100%;
    max-width: 100%;
    overflow: auto;
    position: relative;
}

.uic-virtual-scroll__item {
    left: 0;
    position: absolute;
    right: 0;
}
